import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ThreeDotsWave } from './ThreeDotsWave';

export const BookingBuilderProgress = ({ progress }: { progress: number }) => {
  return (
    <div
      className='mb-4 flex flex-col items-center gap-4 text-balance'
      role='progressbar'
      aria-valuenow={Math.min(100, Math.max(0, Math.round(progress)))}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={t`Confirming your booking`}
    >
      <p className='text-3xl font-bold text-primary'>
        <Trans>Confirming your booking</Trans>
      </p>
      <div className='flex h-10 items-center justify-center gap-2'>
        <p className='text-center font-semibold text-balance' aria-live='polite'>
          {getProgressMessage(progress)}
        </p>
        {progress > 60 && <ThreeDotsWave className='size-8 items-center' />}
      </div>
    </div>
  );
};

const getProgressMessage = (progress: number): string => {
  const parsedValue = Math.floor(progress);

  if (parsedValue < 60) {
    // eslint-disable-next-line noddi/no-banned-ui-terms -- consumer copy: end customers read 'technician'; 'worker' is the backoffice term
    return t`Matching you with a certified technician`;
  }

  return t`Finalizing your booking`;
};
